import React, { useState } from 'react';
import axiosInstance from '../axiosConfig';
import { Link, useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post('/login/', { username, password });

      if (response.data.access && response.data.refresh) {
        localStorage.setItem('access_token', response.data.access);
        localStorage.setItem('refresh_token', response.data.refresh);
        // Store user profile indicating this is NOT a club user
        localStorage.setItem('user_profile', JSON.stringify({ is_club: false }));
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`;
        setMessage("Login successful");

        const profileResponse = await axiosInstance.get('/check-profile-complete/');
        if (profileResponse.data.profile_complete) {
          navigate('/courses');
        } else {
          navigate('/profile-setup');
        }
      } else {
        setMessage("Failed - both username and password are case sensitive.");
      }
    } catch (error) {
      console.error("Login failed:", error);
      setMessage("Login failed. Invalid credentials.");
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleLogin} className="login-form">
        <h2 className="login-header">Member Login</h2>
        <input
          className="login-input"
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          className="login-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" className="login-button">Login</button>
        {message && <p className="login-message">{message}</p>}
      </form>
      <div className="login-footer">
        <p>
          Need an account? <Link to="/register">Register</Link>
        </p>
        <p>
          <Link to="/forgot-password">Forgot Password?</Link>
          {' | '}
          <Link to="/forgot-username">Forgot Username?</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;